export const CURRENCY_TO_COUNTRY_MAPPING: Record<string, string> = {
  // Major currencies
  USD: 'US', // US Dollar
  EUR: 'EU', // Euro
  GBP: 'GB', // British Pound
  JPY: 'JP', // Japanese Yen
  CHF: 'CH', // Swiss Franc
  CAD: 'CA', // Canadian Dollar
  AUD: 'AU', // Australian Dollar
  NZD: 'NZ', // New Zealand Dollar
  RUB: 'RU', // Russian Ruble

  // European currencies
  DKK: 'DK', // Danish Krone
  NOK: 'NO', // Norwegian Krone
  SEK: 'SE', // Swedish Krona
  PLN: 'PL', // Polish Zloty
  CZK: 'CZ', // Czech Koruna
  HUF: 'HU', // Hungarian Forint
  RON: 'RO', // Romanian Leu
  BGN: 'BG', // Bulgarian Lev
  HRK: 'HR', // Croatian Kuna
  RSD: 'RS', // Serbian Dinar
  MKD: 'MK', // Macedonian Denar
  BAM: 'BA', // Bosnia and Herzegovina Convertible Mark
  ALL: 'AL', // Albanian Lek
  ISK: 'IS', // Icelandic Krona

  // Asian currencies
  CNY: 'CN', // Chinese Yuan
  KRW: 'KR', // South Korean Won
  SGD: 'SG', // Singapore Dollar
  HKD: 'HK', // Hong Kong Dollar
  TWD: 'TW', // New Taiwan Dollar
  THB: 'TH', // Thai Baht
  MYR: 'MY', // Malaysian Ringgit
  IDR: 'ID', // Indonesian Rupiah
  PHP: 'PH', // Philippine Peso
  VND: 'VN', // Vietnamese Dong
  INR: 'IN', // Indian Rupee
  PKR: 'PK', // Pakistani Rupee
  BDT: 'BD', // Bangladeshi Taka
  LKR: 'LK', // Sri Lankan Rupee
  NPR: 'NP', // Nepalese Rupee
  MMK: 'MM', // Myanmar Kyat
  KHR: 'KH', // Cambodian Riel
  LAK: 'LA', // Lao Kip
  BND: 'BN', // Brunei Dollar

  // Middle East and Africa
  SAR: 'SA', // Saudi Riyal
  QAR: 'QA', // Qatari Riyal
  KWD: 'KW', // Kuwaiti Dinar
  BHD: 'BH', // Bahraini Dinar
  OMR: 'OM', // Omani Rial
  JOD: 'JO', // Jordanian Dinar
  LBP: 'LB', // Lebanese Pound
  ILS: 'IL', // Israeli Shekel
  EGP: 'EG', // Egyptian Pound
  TRY: 'TR', // Turkish Lira
  IRR: 'IR', // Iranian Rial
  IQD: 'IQ', // Iraqi Dinar
  AFN: 'AF', // Afghan Afghani

  // African currencies
  ZAR: 'ZA', // South African Rand
  NGN: 'NG', // Nigerian Naira
  KES: 'KE', // Kenyan Shilling
  UGX: 'UG', // Ugandan Shilling
  TZS: 'TZ', // Tanzanian Shilling
  ETB: 'ET', // Ethiopian Birr
  GHS: 'GH', // Ghanaian Cedi
  MAD: 'MA', // Moroccan Dirham
  TND: 'TN', // Tunisian Dinar
  DZD: 'DZ', // Algerian Dinar
  LYD: 'LY', // Libyan Dinar
  SDG: 'SD', // Sudanese Pound
  SSP: 'SS', // South Sudanese Pound
  CDF: 'CD', // Congolese Franc
  XAF: 'CM', // Central African CFA Franc (Cameroon)
  XOF: 'SN', // West African CFA Franc (Senegal)
  BWP: 'BW', // Botswana Pula
  ZMW: 'ZM', // Zambian Kwacha
  ZWL: 'ZW', // Zimbabwean Dollar
  MUR: 'MU', // Mauritian Rupee
  SCR: 'SC', // Seychellois Rupee
  MGA: 'MG', // Malagasy Ariary
  MWK: 'MW', // Malawian Kwacha
  SLL: 'SL', // Sierra Leonean Leone
  LRD: 'LR', // Liberian Dollar
  GMD: 'GM', // Gambian Dalasi
  GNF: 'GN', // Guinean Franc
  CVE: 'CV', // Cape Verdean Escudo
  STN: 'ST', // São Tomé and Príncipe Dobra
  AOA: 'AO', // Angolan Kwanza
  MZN: 'MZ', // Mozambican Metical

  // American currencies
  MXN: 'MX', // Mexican Peso
  BRL: 'BR', // Brazilian Real
  ARS: 'AR', // Argentine Peso
  CLP: 'CL', // Chilean Peso
  COP: 'CO', // Colombian Peso
  PEN: 'PE', // Peruvian Sol
  UYU: 'UY', // Uruguayan Peso
  PYG: 'PY', // Paraguayan Guarani
  BOB: 'BO', // Bolivian Boliviano
  VES: 'VE', // Venezuelan Bolívar
  GYD: 'GY', // Guyanese Dollar
  SRD: 'SR', // Surinamese Dollar
  TTD: 'TT', // Trinidad and Tobago Dollar
  JMD: 'JM', // Jamaican Dollar
  BBD: 'BB', // Barbadian Dollar
  BZD: 'BZ', // Belize Dollar
  GTQ: 'GT', // Guatemalan Quetzal
  HNL: 'HN', // Honduran Lempira
  NIO: 'NI', // Nicaraguan Córdoba
  CRC: 'CR', // Costa Rican Colón
  PAB: 'PA', // Panamanian Balboa
  DOP: 'DO', // Dominican Peso
  HTG: 'HT', // Haitian Gourde
  CUP: 'CU', // Cuban Peso
  XCD: 'DM', // East Caribbean Dollar (Dominica)

  // Oceania
  FJD: 'FJ', // Fijian Dollar
  PGK: 'PG', // Papua New Guinean Kina
  SBD: 'SB', // Solomon Islands Dollar
  VUV: 'VU', // Vanuatu Vatu
  WST: 'WS', // Samoan Tala
  TOP: 'TO', // Tongan Paʻanga
  KID: 'KI', // Kiribati Dollar
  TVD: 'TV', // Tuvaluan Dollar

  // Special cases
  XDR: 'UN', // Special Drawing Rights (IMF)
  XAU: 'UN', // Gold
  XAG: 'UN', // Silver
  XPT: 'UN', // Platinum
  XPD: 'UN', // Palladium
  TOTAL: 'all', // default

  AMD: 'AM',
  ANG: 'AN',
  AED: 'AE',
  ERN: 'ER',
  UAH: 'UA',
  // ANG: 'NL',
};
